export default {
  list: {
    loadError: '無法載入研究，請重試。',
  },
  notFound: {
    shareRevoked: '擁有者已停止分享此連結。',
    title: '找不到研究',
    goToStudies: '前往研究列表',
    noAccess: '此研究不存在，或您沒有存取權限。',
    couldNotLoad: '無法載入此研究。',
  },
  pageError: {
    title: '此頁面發生錯誤',
    body: '您的研究仍然存在。請重新載入頁面再試一次；如果問題持續發生，請告訴我們。',
  },
  staleBundle: {
    title: '有新版本可用',
    body: '此分頁自上次部署以來一直開著，正在嘗試載入已移動的資源。請重新載入頁面以取得新版本 — 您的研究仍然存在。',
    reload: '重新載入',
  },
  results: {
    notReadyTitle: '結果尚未就緒',
    notReadyMessage: '模擬完成或停止並儲存診斷資料後，即可查看結果。',
    simulationsRunning: '部分模擬仍在執行中。返回「模擬」頁面即可查看進度。',
    backToSimulate: '查看模擬',
  },
  diagnose: {
    preprocessingMessage: '診斷現已納入網格化步驟。',
    movedTitle: '診斷已移至網格化',
    draftMessage: '請在執行研究前，使用網格化步驟設定網格參數。',
    sharedMessage: '診斷與網格化現在共用網格化步驟。',
  },
  status: {
    unknownTitle: '未知狀態',
    unknownMessage: '研究處於無法辨識的狀態（{{state}}）。',
  },
  simulate: {
    notYetTitle: '尚未開始模擬',
    notYetMessage: '待網格化步驟完成後，模擬即會開始。',
    completeTitle: '模擬完成',
    completeMessage: '此研究已進入模擬步驟之後的階段。',
  },
} as const;
